import type { ReactNode } from 'react';
import { cx } from './tokens';

/**
 * A rubber-stamped verdict: rotated, double-ruled, slightly bled. Used for
 * outcomes, the chaos banner and the executed marker.
 */
export function Stamp({
  children,
  tone = 'red',
  size = 'md',
  className,
}: {
  children: ReactNode;
  tone?: 'red' | 'teal' | 'ink';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const tones = {
    red: 'border-red text-red',
    teal: 'border-teal text-teal',
    ink: 'border-ink text-ink',
  } as const;

  const sizes = {
    sm: 'px-2 py-1 text-[0.65rem] border-2 tracking-[0.16em]',
    md: 'px-4 py-2 text-lg border-[3px] tracking-[0.18em]',
    lg: 'px-[3vw] py-[1.4vh] text-screen-lg border-[6px] tracking-[0.16em]',
  } as const;

  return (
    <span
      className={cx(
        'inline-block font-display uppercase leading-none',
        'bg-paper-raised/70',
        tones[tone],
        sizes[size],
        className,
      )}
      style={{ boxShadow: 'inset 0 0 0 2px color-mix(in srgb, currentColor 22%, transparent)' }}
    >
      {children}
    </span>
  );
}
